import { Nullable } from 'common-types';
import SlackStore from '../store/slack-store';
import { Channel, GetSlackChannelsList } from '../types/slack-types';

export const setLoadingSlackChannels = (isLoading: boolean) => {
  SlackStore.loadingSlackChannels = isLoading;
};

export const setLoadingSubmit = (isLoading: boolean) => {
  SlackStore.loadingSubmit = isLoading;
};

export const setChannels = ({
  channels,
  suggestedChannel,
}: GetSlackChannelsList) => {
  SlackStore.publicChannels = channels;
  SlackStore.fields.selectedChannel = suggestedChannel;
};

export const resetFields = () => {
  SlackStore.fields = {
    selectedChannel: null,
    userComment: '',
  };
};

export const setSelectedChannel = (selectedChannel: Nullable<Channel>) => {
  SlackStore.fields.selectedChannel = selectedChannel;
};

export const setUserComment = (userComment: string) => {
  SlackStore.fields.userComment = userComment;
};
